import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '@/api';
import { HiArrowLeft } from 'react-icons/hi2';
import { toArray } from "../utils/toArray";
import CandidateCard from '@/components/CandidateCard';

const MatchingPage = () => {
    const { id } = useParams();
    const [matches, setMatches] = useState([]);
    const [offre, setOffre] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchMatches = async () => {
            setIsLoading(true);
            try {
                const offreResponse = await api.get(`/offres/${id}`);
                setOffre(offreResponse.data);
                const matchesResponse = await api.get(`/offres/${id}/matches`);
                setMatches(Array.isArray(matchesResponse.data) ? matchesResponse.data : []);
            } catch (error) {
                console.error("Erreur lors de la récupération des correspondances:", error);
                setMatches([]);
            } finally {
                setIsLoading(false);
            }
        };
        fetchMatches();
    }, [id]);

    if (isLoading) {
        return <p className="text-center text-pro-dark-text-secondary">Analyse des correspondances par l'IA...</p>;
    }

    return (
        <div>
            <Link to="/offres" className="flex items-center gap-2 text-sm text-pro-dark-text-secondary hover:text-pro-dark-accent mb-6">
                <HiArrowLeft />
                Retour à la liste des offres
            </Link>
            {offre && (
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-pro-dark-text-primary">Correspondances pour : {offre.detailDuBesoin}</h1>
                    <p className="text-md text-pro-dark-text-secondary">Compte : {offre.compte}</p>
                </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {toArray(matches).map(match => (
                    <CandidateCard
                        key={match.candidat.id}
                        candidat={match.candidat}
                        matchPercentage={match.finalScore}
                        summary={match.summary}
                    />
                ))}
            </div>
            {matches.length === 0 && !isLoading && (
                <div className="text-center py-12">
                    <p className="text-pro-dark-text-secondary">Aucun candidat correspondant trouvé.</p>
                </div>
            )}
        </div>
    );
};

export default MatchingPage;